import { Card } from '@checkatrade/web-ui';

export const SearchListPlaceholders = ({
  pageLength = 6,
}: {
  pageLength: number;
}) => {
  const placeholders = [];

  for (let i = 0; i < pageLength; i += 1) {
    placeholders.push(
      <Card key={`search-placeholder-${i}`} className="w-full p-6">
        <div className="mb-4 flex w-full gap-3">
          <div className="mb-2 size-24 animate-pulse rounded-lg bg-neutral-10" />
          <div className="flex flex-1 flex-col gap-3">
            <div className="h-6 w-full animate-pulse rounded-lg bg-neutral-10 md:w-1/2" />
            <div className="h-6 w-28 animate-pulse rounded-lg bg-neutral-10" />
            <div className="h-4 w-32 animate-pulse rounded-lg bg-neutral-10" />
          </div>
        </div>
        <div className="flex flex-1 flex-col gap-6 md:flex-row">
          <div className="flex flex-1 flex-col">
            <div className="mb-2 h-6 w-full animate-pulse rounded-lg bg-neutral-10" />
            <div className="mb-2 h-6 w-full animate-pulse rounded-lg bg-neutral-10" />
          </div>
          <div className="flex flex-col gap-2">
            <div className="h-10 w-full animate-pulse rounded-full bg-neutral-10 md:w-64" />
            <div className="h-10 w-full animate-pulse rounded-full bg-neutral-10 md:w-64" />
          </div>
        </div>
      </Card>,
    );
  }

  return placeholders;
};

export default SearchListPlaceholders;
